import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import fullDate from '../DateFunction';
import './ComingSoon.scss';

const ComingSoon = () => {

    const [latest, setLatest] = useState({});

    const [release, setRelease] = useState('');

    const date  = new Date();
    const year = date.getFullYear();
    const getMonth = (date.getMonth() + 1).toString();
    const month = getMonth.length === 1 ? `0${getMonth}` : getMonth;
    const getDay = date.getDate().toString();
    const day = getDay.length === 1 ? `0${getDay}` : getDay;

    const getLatestMovieId = async () => {
        const url1 = `https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API_KEY}&primary_release_date.gte=${year}-${month}-${day}&region=US`
        const request1 = await fetch(url1)
        const csResponse = await request1.json();
        const csData = await csResponse.results;
        const respDataId = csData[0].id;

        const url2 = `https://api.themoviedb.org/3/movie/${respDataId}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`;
        const request2 = await fetch(url2);
        const infoResponse  = await request2.json();
        setLatest(infoResponse);
        setRelease(fullDate(infoResponse.release_date));
    }

    useEffect(() => {
        getLatestMovieId();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="coming-soon" id="coming-soon">
            <div className="coming-soon-header"></div>
            <div className="coming-soon-content">
                <div className="coming-soon-img-container">
                    <Link to={`/movie/${latest.id}`}>
                        <img src={(`https://image.tmdb.org/t/p/original${latest.poster_path}`)} alt={latest.title} />
                    </Link>
                </div>
                <div className="coming-soon-info">
                    <h2>Coming Soon!</h2>
                    <h1 className="coming-soon-title">{latest.title}</h1>
                    <p className="coming-soon-p">{latest.overview}</p>
                    <h3>Release Date</h3>
                    {/* {() => (<p className="coming-soon-p">{fullDate(latest.release_date)}</p>)} */}
                    <p className="coming-soon-p">{release}</p>
                    <Link to={`/movie/${latest.id}`} className="coming-soon-trailer-btn">more details</Link>
                </div>
            </div>
        </div>
    )
}

export default ComingSoon
